import Icon from "components/atom/Icon.tsx";
import { InvoiceType } from "globals/types/globals.ts";
import { useMemo } from "react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

function InvoiceCard(props: { invoice: InvoiceType, onDownload: () => void }) {
  const { invoice, onDownload } = props;

  const { t } = useTranslation();

  const createdAt = useMemo(() => {
    return dayjs(invoice.created).format("LLL");
  }, [invoice]);

  //trial invoice are 0$
  if (invoice.total === 0) {
    return null;
  }

  return (
    <div className="rounded-md border border-gray-300 p-2">
      <div className="flex flex-row items-center justify-between gap-4">
        <div className="flex flex-row items-center justify-start gap-4">
          <p className="text-xs font-medium text-black">
            {invoice.number}
          </p>

          <div>
            <p className="text-xs font-medium text-black">
              {invoice.total / 100}$ {invoice.currency.toUpperCase()}
            </p>
            <p className="pt-1 text-xs font-medium">
              {createdAt}
            </p>
          </div>
        </div>
        <button type="button"
                className="cursor-pointer appearance-none px-2 flex flex-row items-center justify-end gap-1"
                onClick={onDownload}
        >
          <span className="text-xs text-gray-400">
            {t("download")}
          </span>
          <Icon name="angle-right"
                className="h-4 w-4 min-w-4 text-gray-400" />
        </button>
      </div>
    </div>
  );
}

export default InvoiceCard;
